module.exports = __webpack_public_path__ + "img/3-5.def7c854.svg";